// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calls-dashboard-nav-button {
  background-color: #1F2937;
  border-color: #1F2937;
  color: white;
}

.calls-dashboard-nav-button:hover {
  background-color: #435164;
  border-color: #435164;
  color: white;
}

.navbar-top {
  background-color: #1F2937 !important;
}

.loading-dots::after {
  content: '.';
  animation: dots 1.5s steps(3, end) infinite;
}

.btn-dark.theme-toggle {
    background-color: #000000;
    transform: scale(1.15);
}

.btn-dark.theme-toggle:hover {
    background-color: #3b3b3b;
    transform: scale(1.20) translateY(-1px);
}

.btn-light.theme-toggle {
    background-color: #ffffff;
    transform: scale(1.15);
}

.btn-light.theme-toggle:hover {
    background-color: #d4d4d4;
    transform: scale(1.20) translateY(-1px);
}


@keyframes dots {
  0% { content: '.'; }
  33% { content: '..'; }
  66% { content: '...'; }
}

/*.g-sidenav-hidden .sidenav {
  background-color: lightblue !important;
}*/


.husaria-header, .admin-header {
  background-color: #172b4d; /* husaria default */
}
/* Specific overrides */
.hucs-header,
.voicemail-header, .hucs{
  background-color: #A11002 !important;
}

.hrms-header, .hrms{
  background-color: #D06C01 !important;
}

.mdm-header, .mdm{
  background-color: #146F06;
}

.hans-header, .hans{
  background-color: #324A62;
}

.dealer-header, .dealer{
  background-color: #696969;
}

.collapsing {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.nav-item > span {
  color: white ;
}

.collapse,
.show{
  display: flex;
  justify-content: flex-end !important;
}

.page-menu {
  display: block;
}

.nav {
  border-radius: 10px 10px 10px 10px;
  padding-left: 0 !important;
}

.nav-link:not(.pr-0) {
  padding-left: 1rem !important;
  padding-right: 0rem !important;
  height: 34px;
}

.hucs-active.active  {
  background-color: #FD6B5E !important;
}

.route-link {
/*margin-left: 1rem;*/
  width: 100%;
  padding-right: 0rem;
}

.hucs .nav-link.active.route-link {
  background-color: #FD6B5E;
  padding-left: 0;
}

.hucs .nav-link:hover {
  background-color: #FD4130;
}

.hrms .nav-link:hover {
  background-color: #FE9A2F;
}

:is(.hucs, .hrms, .mdm) .nav-link > span, .nav-link.active > span {
  color: white;
}

/*.nav-link:not(.hucs-active):not(.hrms-active):not(.mdm-active):not(.route-link):not(.home):not(.account-links), .hucs > .nav-item > .dashboard {
  margin-left: 0.5rem;
}*/

.home-icon {
  padding-right: 0.175em;
}

.hrms .nav-link.active, .hrms-active.active  {
  background-color: #FEB05D !important;
  padding-left: 0;
}

.mdm .nav-link.active, .mdm-active.active   {
  background-color: #1C9A09 !important;
  border-radius: 10px 10px 10px 10px;
  padding-left: 0;
}

.hans .nav-link.active, .hans-active.active   {
  background-color: #5780A8 !important;
  border-radius: 10px 10px 10px 10px;
  padding-left: 0;
}

.alert {
  display: block;
}

.return-dealer-menu:hover {
  cursor: pointer;
}

.return-dealer-menu {
  text-decoration: underline;
  color: white;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/components/css/husaria.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;AAC3C;;;AAGA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,aAAa,EAAE;EACrB,MAAM,cAAc,EAAE;AACxB;;AAEA;;EAEE;;;AAGF;EACE,yBAAyB,EAAE,oBAAoB;AACjD;AACA,uBAAuB;AACvB;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;AACA,qBAAqB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".calls-dashboard-nav-button {\r\n  background-color: #1F2937;\r\n  border-color: #1F2937;\r\n  color: white;\r\n}\r\n\r\n.calls-dashboard-nav-button:hover {\r\n  background-color: #435164;\r\n  border-color: #435164;\r\n  color: white;\r\n}\r\n\r\n.navbar-top {\r\n  background-color: #1F2937 !important;\r\n}\r\n\r\n.loading-dots::after {\r\n  content: '.';\r\n  animation: dots 1.5s steps(3, end) infinite;\r\n}\r\n\r\n.btn-dark.theme-toggle {\r\n    background-color: #000000;\r\n    transform: scale(1.15);\r\n}\r\n\r\n.btn-dark.theme-toggle:hover {\r\n    background-color: #3b3b3b;\r\n    transform: scale(1.20) translateY(-1px);\r\n}\r\n\r\n.btn-light.theme-toggle {\r\n    background-color: #ffffff;\r\n    transform: scale(1.15);\r\n}\r\n\r\n.btn-light.theme-toggle:hover {\r\n    background-color: #d4d4d4;\r\n    transform: scale(1.20) translateY(-1px);\r\n}\r\n\r\n\r\n@keyframes dots {\r\n  0% { content: '.'; }\r\n  33% { content: '..'; }\r\n  66% { content: '...'; }\r\n}\r\n\r\n/*.g-sidenav-hidden .sidenav {\r\n  background-color: lightblue !important;\r\n}*/\r\n\r\n\r\n.husaria-header, .admin-header {\r\n  background-color: #172b4d; /* husaria default */\r\n}\r\n/* Specific overrides */\r\n.hucs-header,\r\n.voicemail-header, .hucs{\r\n  background-color: #A11002 !important;\r\n}\r\n\r\n.hrms-header, .hrms{\r\n  background-color: #D06C01 !important;\r\n}\r\n\r\n.mdm-header, .mdm{\r\n  background-color: #146F06;\r\n}\r\n\r\n.hans-header, .hans{\r\n  background-color: #324A62;\r\n}\r\n\r\n.dealer-header, .dealer{\r\n  background-color: #696969;\r\n}\r\n\r\n.collapsing {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n}\r\n\r\n.nav-item > span {\r\n  color: white ;\r\n}\r\n\r\n.collapse,\r\n.show{\r\n  display: flex;\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.page-menu {\r\n  display: block;\r\n}\r\n\r\n.nav {\r\n  border-radius: 10px 10px 10px 10px;\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.nav-link:not(.pr-0) {\r\n  padding-left: 1rem !important;\r\n  padding-right: 0rem !important;\r\n  height: 34px;\r\n}\r\n\r\n.hucs-active.active  {\r\n  background-color: #FD6B5E !important;\r\n}\r\n\r\n.route-link {\r\n/*margin-left: 1rem;*/\r\n  width: 100%;\r\n  padding-right: 0rem;\r\n}\r\n\r\n.hucs .nav-link.active.route-link {\r\n  background-color: #FD6B5E;\r\n  padding-left: 0;\r\n}\r\n\r\n.hucs .nav-link:hover {\r\n  background-color: #FD4130;\r\n}\r\n\r\n.hrms .nav-link:hover {\r\n  background-color: #FE9A2F;\r\n}\r\n\r\n:is(.hucs, .hrms, .mdm) .nav-link > span, .nav-link.active > span {\r\n  color: white;\r\n}\r\n\r\n/*.nav-link:not(.hucs-active):not(.hrms-active):not(.mdm-active):not(.route-link):not(.home):not(.account-links), .hucs > .nav-item > .dashboard {\r\n  margin-left: 0.5rem;\r\n}*/\r\n\r\n.home-icon {\r\n  padding-right: 0.175em;\r\n}\r\n\r\n.hrms .nav-link.active, .hrms-active.active  {\r\n  background-color: #FEB05D !important;\r\n  padding-left: 0;\r\n}\r\n\r\n.mdm .nav-link.active, .mdm-active.active   {\r\n  background-color: #1C9A09 !important;\r\n  border-radius: 10px 10px 10px 10px;\r\n  padding-left: 0;\r\n}\r\n\r\n.hans .nav-link.active, .hans-active.active   {\r\n  background-color: #5780A8 !important;\r\n  border-radius: 10px 10px 10px 10px;\r\n  padding-left: 0;\r\n}\r\n\r\n.alert {\r\n  display: block;\r\n}\r\n\r\n.return-dealer-menu:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.return-dealer-menu {\r\n  text-decoration: underline;\r\n  color: white;\r\n  margin-bottom: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
